// removed by extract-text-webpack-plugin
module.exports = {"component":"Style__component___38-GH","modal":"Style__modal___17rUH"};


//////////////////
// WEBPACK FOOTER
// ./client/components/layout/ModalLoader/Style.css
// module id = 2046
// module chunks = 0